<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 16.1L4.04 20.92L7.66 17.73L13.76 4.02999L10.11 2.39999L4 16.1Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
<rect x="7" y="21" width="14" height="2" fill="currentColor"/>
</svg>
